if (!window.customProductBadgesInitialized) {
  window.customProductBadgesInitialized = true;

  // setTimeout delays beyond ~24.8 days overflow the 32-bit signed int Chrome/V8
  // uses internally and fire almost immediately. Cap every scheduled delay and
  // re-check instead of scheduling the full remaining time in one shot.
  const MAX_DELAY = 20 * 24 * 60 * 60 * 1000; // 20 days

  const scheduleAt = (targetTimestamp, callback) => {
    const remainingTime = targetTimestamp - Date.now();

    if (remainingTime <= 0) {
      callback();
    } else if (remainingTime > MAX_DELAY) {
      setTimeout(() => scheduleAt(targetTimestamp, callback), MAX_DELAY);
    } else {
      setTimeout(callback, remainingTime);
    }
  };

  const initBadgeTimers = () => {
    document.querySelectorAll('[data-custom-badge][data-end]:not([data-end-tracked])').forEach((badge) => {
      badge.setAttribute('data-end-tracked', 'true');
      const endTimestamp = parseInt(badge.getAttribute('data-end'), 10);

      scheduleAt(endTimestamp, () => {
        badge.style.opacity = '0';
        badge.style.transform = 'scale(0.8)';
        setTimeout(() => badge.remove(), 300);
      });
    });

    document.querySelectorAll('[data-custom-badge][data-start]:not([data-start-tracked])').forEach((badge) => {
      badge.setAttribute('data-start-tracked', 'true');
      const startTimestamp = parseInt(badge.getAttribute('data-start'), 10);

      scheduleAt(startTimestamp, () => {
        badge.removeAttribute('hidden');
        badge.classList.add('is-appearing');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadgeTimers);
  } else {
    initBadgeTimers();
  }

  const observer = new MutationObserver(() => initBadgeTimers());

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
